<template>
    <div class="shortcuts">
        <Menu></Menu>
    </div>
</template>
<script>
    import Menu from './Menu';
    export default{
        components:{
            Menu
        }
    }

</script>